<i18n>
{
  "ru":{
    "technical_alert_text": "Внимание! Ведутся технические работы, возможны неполадки."
  },
  "en":{
    "technical_alert_text": "Attention! Technical work is underway, possible malfunctions."
  }
}
</i18n>

<template >
    <div v-if="displayTechnicalAlert" id="technicalAlertBlock">
      <span id="technicalAlertContent">{{
          $t("technical_alert_text")
        }}</span>
    </div>
</template>

<script>

export default {
  name: 'technical-alert',
  data: () => ({
    technicalAlertUrl: `${process.env.VUE_APP_BASE_API_URL}/technical_alert`,
    hasTechnicalAlert: process.env.VUE_APP_SANDBOX === '1',
    displayTechnicalAlert: false,
  }),
  created() {
    if (this.hasTechnicalAlert) {
      this.getTechnicalAlert()
    }
  },
  methods: {
    async getTechnicalAlert() {
      const response = await fetch(this.technicalAlertUrl, {
        method: 'GET',
      })

      const responseData = await response.json()
      if (response.status === 200 && responseData.hasOwnProperty('hasAlert')) {
        this.displayTechnicalAlert = responseData.hasAlert
      }
    }
  }
}
</script>

<style>
#technicalAlertBlock {
  line-height: 50px;
  background-color: #ffca7a96;
  text-align: center;
}
#technicalAlertContent {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
</style>
